const avatarColors = ["#9EAAB4", "#CFB47C", "#157663", "#FFBCAF", "#9F1535"]

export const getAvatarUserColor = (name: string) => {
  return (name?.length ?? 0) > 0
    ? avatarColors[name.charCodeAt(0) % avatarColors.length]
    : avatarColors[0]
}
